<template>
  <div
    class="flex gap-4 flex-wrap text-gray-600"
  >
    <button
      v-if="productType === 'LIGHT'"
      :class="btnClass"
      @click="upgradeToBasic()"
    >
      <fa :icon="faAngleUp" />
      Auf BASIC upgraden
    </button>

    <button
      v-if="productType !== 'EXPERT'"
      :class="btnClass"
      @click="upgradeToExpert()"
    >
      <fa :icon="faAngleDoubleUp" />
      Auf EXPERT upgraden
    </button>
  </div>
</template>

<script>
import { faAngleUp, faAngleDoubleUp } from '@fortawesome/free-solid-svg-icons'
import UPGRADE_COMPANY_MANUALLY_TO_BASIC from '@/graphql/UpgradeCompanyManuallyToBasic.gql'
import UPGRADE_COMPANY_MANUALLY_TO_EXPERT from '@/graphql/UpgradeCompanyManuallyToExpert.gql'
import feature from '@/mixins/feature'

export default {
  mixins: [feature],
  props: {
    companyId: {
      type: String,
      required: true
    },
    productType: {
      type: String,
      required: true
    },
    btnClass: {
      type: String,
      default: 'btn-danger'
    }
  },
  data () {
    return {
      faAngleUp,
      faAngleDoubleUp
    }
  },
  computed: {
    isBillwerFeatureActive () {
      return this.isFeatureActive(this.featureNames.BILLWERK)
    }
  },
  methods: {
    async upgradeToExpert () {
      const hasConfirmed = this.isBillwerFeatureActive
        ? confirm('Soll die Firma wirklich auf EXPERT geupgradet werden? Das sollte nur in Ausnahmefällen gemacht werden, z.B. um das Onboarding vorzuziehen. Das ersetzt nicht das Upgrade in Billwerk.')
        : confirm('Soll die Firma wirklich auf EXPERT geupgradet werden?')

      if (hasConfirmed) {
        await this.$apollo.mutate({
          mutation: UPGRADE_COMPANY_MANUALLY_TO_EXPERT,
          variables: {
            companyId: this.companyId
          }
        })
        this.$router.go(0)
      }
    },
    async upgradeToBasic () {
      const hasConfirmed = this.isBillwerFeatureActive
        ? confirm('Soll die Firma wirklich auf BASIC geupgradet werden? Das sollte nur in Ausnahmefällen gemacht werden, z.B. um das Onboarding vorzuziehen. Das ersetzt nicht das Upgrade in Billwerk.')
        : confirm('Soll die Firma wirklich auf BASIC geupgradet werden?')

      if (hasConfirmed) {
        await this.$apollo.mutate({
          mutation: UPGRADE_COMPANY_MANUALLY_TO_BASIC,
          variables: {
            companyId: this.companyId
          }
        })
        this.$router.go(0)
      }
    }
  }
}
</script>
